import {PolyDictionary} from '../../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {Ref} from 'vue';
import {BaseCodeDisplayer} from './_Base';
import type {ActorSopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/Actor';
import type {ObjectBuilderSopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/ObjectBuilder';
import type {PointBuilderSopNode} from '../../../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/PointBuilder';

export class FunctionDataCodeDisplayer {
	static async update(
		node: ActorSopNode | ObjectBuilderSopNode | PointBuilderSopNode,
		shadersByName: Ref<PolyDictionary<string | null>>,
		shaderNames: Ref<string[]>
	) {
		await node.compute();
		BaseCodeDisplayer.clear(shadersByName, shaderNames);
		const code = node.functionData()?.functionBody;
		shadersByName.value['main'] = code || '';
		shaderNames.value.push('main');
	}
}
